module.exports = __webpack_public_path__ + "img/T2A_rc_8.650f5f53.png";